import { Models } from "@hex-insights/app-modules";
import { fromTime, isSameTime, stringToLocalDate } from "@hex-insights/core";

const dateFormat: Intl.DateTimeFormatOptions = { month: "short", day: "numeric" };
const timeFormat: Intl.DateTimeFormatOptions = { hour: "numeric", minute: "2-digit" };
const dateTimeFormat: Intl.DateTimeFormatOptions = { ...dateFormat, hour: "numeric", minute: "2-digit" };

export type DateOptions = Intl.DateTimeFormatOptions;

export function date(value: string | null, options: DateOptions = {}) {
	if (!value) {
		return Models.toString(value);
	}
	const valueDate = stringToLocalDate(value, "day");
	if (isSameTime(valueDate, new Date(), "year")) {
		return valueDate.toLocaleString(undefined, { ...dateFormat, ...options });
	}
	return valueDate.toLocaleString(undefined, { ...dateFormat, year: "numeric", ...options });
}

export type TimeOptions = DateOptions & {
	noDate?: boolean;
};

export function time(value: string | null, { noDate, ...options }: TimeOptions = {}) {
	if (!value) {
		return Models.toString(value);
	}
	const valueDate = new Date(value);
	if (noDate) {
		return valueDate.toLocaleString(undefined, { ...timeFormat, ...options });
	}
	if (isSameTime(valueDate, new Date(), "year")) {
		return valueDate.toLocaleString(undefined, { ...dateTimeFormat, ...options });
	}
	return valueDate.toLocaleString(undefined, { ...dateTimeFormat, year: "numeric", ...options });
}

export function minutes(value: number | null) {
	if (!value) {
		return Models.toString(value);
	}
	const date = fromTime(value, "minute", new Date());
	return date.toLocaleString(undefined, { hour: "numeric", minute: "2-digit" });
}
